import { graphql } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import imagesLoaded from "imagesloaded";
import "./img.scss";
import classNames from "classnames";
import useInViewport from "hooks/utils/useInViewport";

export interface ImgFixedProps {
  altText?: string;
  sourceUrl?: string;
  localFile: {
    childImageSharp?: {
      gatsbyImageData: {
        images: {
          fallback: {
            src: string;
            srcSet: string;
            sizes: string;
          };
        };
      };
    };
    publicURL: string;
  };
}

interface Props extends ImgFixedProps {
  className?: string;
  noLazy?: boolean;
}

const Img: React.FC<Props> = (props) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const mainRef = useRef<HTMLImageElement>(null);
  const inViewport = useInViewport(mainRef, true);

  // useEffect(() => {
  //   if (!!inViewport && !isLoaded) {
  //     const main = mainRef.current;
  //     if (!!main) {
  //       imagesLoaded(main, () => {
  //         setIsLoaded(true);
  //       });
  //     } else {
  //       setIsLoaded(true);
  //     }
  //   }
  // }, [inViewport]);

  if (!!props.localFile) {
    if (!!props.localFile.childImageSharp) {
      return (
        <img
          // src={props.localFile.childImageSharp.gatsbyImageData.images.fallback.src}
          src={
            inViewport || props.noLazy ? props.localFile.childImageSharp.gatsbyImageData.images.fallback.src : undefined
          }
          alt={props.altText}
          className={classNames(props.className, 'img')}
          style={{opacity: isLoaded || props.noLazy ? 1 : 0}}
          onLoad={() => {
            setIsLoaded(true);
          }}
          ref={mainRef}
        />
      );
    } else if (!!props.localFile.publicURL) {
      return (
        <img
          src={props.localFile.publicURL}
          alt={props.altText}
          className={props.className}
          ref={mainRef}
        />
      );
    }
  }

  return null;
};

export default Img;

export const query = graphql`
  fragment ImgBackground on WpMediaItem {
    altText
    sourceUrl
    localFile {
      publicURL
      childImageSharp {
        gatsbyImageData(width: 1600, quality: 80, formats: [AUTO, WEBP, AVIF])
      }
    }
  }
  fragment ImgLarge on WpMediaItem {
    altText
    sourceUrl
    localFile {
      publicURL
      childImageSharp {
        gatsbyImageData(width: 1440, quality: 80)
      }
    }
  }
  fragment ImgMedium on WpMediaItem {
    altText
    sourceUrl
    localFile {
      publicURL
      childImageSharp {
        gatsbyImageData(width: 900, quality: 80)
      }
    }
  }
  fragment ImgOriginal on WpMediaItem {
    altText
    sourceUrl
    localFile {
      publicURL
      childImageSharp {
        gatsbyImageData(quality: 80)
      }
    }
  }
  fragment ImgSVG on WpMediaItem {
    altText
    sourceUrl
    localFile {
      publicURL
    }
  }
`;
